import language from 'gso-user-language';
import { read } from 'gso-session';
import menuStructure from './menu-structure';
import { getApplications } from './user-proxy';
function handlePetrusApplications(applications) {
    // Some applications have different names follow whether they come from petrus or user-server. No need when Portal (Vue) will be in production.
    const PETRUS_APPLICATION = {
        iout: 'out',
        isenior: 'senior'
    };
    return applications.map(application => Object.assign(application, {
        name: PETRUS_APPLICATION[application.name] || application.name
    }));
}
function createMenu(menuStructure, applications) {
    const menu = [];
    return menuStructure.groups.reduce((groups, group) => {
        const apps = filterGroupApplications(group.apps, handlePetrusApplications(applications));
        return apps.length > 0 ? groups.concat([{ id: group.id, apps }]) : groups;
    }, menu);
}
function filterGroupApplications(menuApplications, applications) {
    return menuApplications.filter((application) => {
        return isApplicationAvailable(application, applications);
    });
}
async function getMenu() {
    const apps = await getApplications();
    return createMenu(menuStructure(language(), read('token')), apps);
}
function handleOutSimApplication(menuApplication, application) {
    if (application.label === 'Out-sim') {
        if (application.options) {
            menuApplication.options = application.options;
        }
        return true;
    }
    return false;
}
function isApplicationAvailable(menuApplication, applications) {
    return applications.some((application) => {
        // to handle OutSim application from Petrus with token if needed.
        if (menuApplication.id === 'out') {
            return handleOutSimApplication(menuApplication, application);
        }
        return (
        // TODO: Remove when new service is available
        // To take in count present undefined as true
        menuApplication.id === application.name && application.present !== false);
    });
}
export { createMenu, // Only for testing
getMenu };
//# sourceMappingURL=apps-menu.js.map